import { render, staticRenderFns } from "./model-chooser.vue?vue&type=template&id=7576cc67&scoped=true"
import script from "./model-chooser.vue?vue&type=script&setup=true&lang=js"
export * from "./model-chooser.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7576cc67",
  null
  
)

export default component.exports